import type { CookedProduct } from '@apps/registry/common/selectors/ProductListSelector';
import { CustomItemDataType } from '@graphql/generated-base';

type PurchaseLine = Pick<CookedProduct, 'custom' | 'isGetCashEquivalent'>;

// Registry gives cash fund, charity and most "get cash equivalent" lines the cash SKU, and any cash line puts the
//   whole order on the Couple's payout account. A GCE gift with a catalog joySKU is a dropship line instead, but
//   the guest query does not fetch that, so every GCE gift counts as cash: it keeps the Couple's key, which is
//   what checkout used before this split
const isCashLine = (product: PurchaseLine) =>
  product.custom?.type === CustomItemDataType.cash || product.custom?.type === CustomItemDataType.charity || !!product.isGetCashEquivalent;

/** No cash line, so commerce charges the order on the dropship Stripe account rather than the Couple's */
export const isDropshipCheckout = (products: ReadonlyArray<PurchaseLine>) => products.length > 0 && !products.some(isCashLine);
